import React from 'react';

import { css } from '@emotion/react';
import { i18n } from '@lingui/core';
import { Dropdown as SemanticDropdown } from 'semantic-ui-react';
import tw from 'twin.macro';

import DangerouslySetInnerHTML from '$/components/ui/EditableInput/DangerouslySetInnerHTML';
import Dropdown from '$/components/ui/Input/Basics/Dropdown';
import { RegistrationFieldType, RegistrationFormFieldInput } from '$/GraphQL/schema/schema';
import { PlusIcon } from '$/images/Icons';
import { useFieldTypeOptions } from './useFieldTypeOptions';

interface AddFieldDropdownProps {
  append: (field: RegistrationFormFieldInput) => void;
  country: string;
}

export const AddFieldDropdown: React.FC<AddFieldDropdownProps> = ({ country, append }) => {
  const fieldTypeOptions = useFieldTypeOptions(country, i18n);

  return (
    <Dropdown
      basic
      floating
      icon={null}
      scrolling
      upward
      className='w-full font-body border-0 p-0'
      defaultValue={RegistrationFieldType.Text}
      trigger={
        <div className='flex w-full rounded-md items-center appearance-no focus:outline-none mt-1/2e mb-1_5e p-1/2e bg-coral-2 text-coral-3'>
          <PlusIcon className='w-1e h-1e mr-1/2e' />
          Add field
        </div>
      }
    >
      <SemanticDropdown.Menu className='w-full'>
        {fieldTypeOptions.map((option, index) => (
          <SemanticDropdown.Item
            key={index}
            className='min-w-10e border-b border-gray-200'
            css={css`
              border-bottom-style: solid !important;
            `}
            onClick={(): void => {
              append({
                fieldName: '',
                isRemovable: true,
                isRequired: false,
                propertyName: '',
                type: option.value,
              });
            }}
            {...option}
            content={
              <div
                className='flex flex-col justify-start w-full text-sm'
                css={css`
                  a {
                    ${tw`text-color-brand`}
                    text-decoration: underline;
                  }
                `}
              >
                <div className='flex flex-col items-start mb-1/4e'>
                  <div className='text-medium text-md'>{option.text}</div>
                </div>
                <DangerouslySetInnerHTML
                  className='whitespace-normal mt-1/2e text-gray-600'
                  markdownString={option.desc ?? ''}
                />
              </div>
            }
          />
        ))}
      </SemanticDropdown.Menu>
    </Dropdown>
  );
};
